import React from 'react';
import { useSelector } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { MDash } from 'ui-components/components/mdash';

import LabeledField from './labeled-field';
import messages from './messages';
import { AddressFormContextProvider } from '../../../../address/address-fields/context';
import { ReadOnlyCountryFields } from '../../../../address/address-fields/read-only-country-fields';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import Global from '../../../../store/global-selectors';

import style from './order-summary.module.less';

const ShipToAddress = () => {
  const salesOrderId = useSalesOrderIdContext();
  // Use marketplace address (original imported address) to show the customer's original address
  const marketplaceShipTo = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'marketplaceShipTos.0',
    }),
  );

  return (
    <LabeledField label={<FormattedMessage {...messages.shipToLabel} />}>
      {marketplaceShipTo ? (
        <AddressFormContextProvider address={marketplaceShipTo}>
          <ReadOnlyCountryFields style={style['field-content']} />
        </AddressFormContextProvider>
      ) : (
        <MDash className={style['field-content']} />
      )}
    </LabeledField>
  );
};

export default ShipToAddress;
